import React, { useState } from "react";
import Button from "../Button";
import Modal from "../Modal";
import moment from "moment";

import { useDispatch } from "react-redux";

import { getSubscription, rescheduleDelivery } from "app/subscriptions/actions";
import ErrorHandling from "shared/ErrorHandling";
import { useStripe } from "@stripe/react-stripe-js";

const GetShipmentNowModal = ({ isOpen, handleClose, subscriptionId }) => {
  const [error, setError] = useState(null);
  const [isSubmitting, setSubmitting] = useState(false);
  const dispatch = useDispatch();
  const nextDeliveryDate = moment().add(0, "day").startOf("day").toDate();
  const [successState, setSuccessState] = useState(null);
  const stripe = useStripe();

  function handleCloseAndReset() {
    handleClose();
    setTimeout(() => {
      setError(null);
      setSuccessState(null);
    }, 1000);
  }

  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleCloseAndReset}
      title="Process next order now"
      subtitle="We will process your next shipment right away"
      successState={successState}
    >
      <ErrorHandling error={error} />
      <div className="mt-4">
        <Button
          btnType="primary"
          disabled={error}
          isLoading={isSubmitting}
          onClick={() => {
            setSubmitting(true);
            dispatch(
              rescheduleDelivery(
                subscriptionId,
                {
                  next_date: nextDeliveryDate
                },
                stripe
              )
            )
              .then(
                () =>
                  setSuccessState({
                    title: "We'll have your coffee on its way to you soon!",
                    subtitle:
                      "A new order has been processed for you and will be despatched within 1-2 working days."
                  }),
                err => {
                  setError(err);
                  // Failing an immediate payment will drop you into failing status
                  dispatch(getSubscription(subscriptionId));
                }
              )
              .finally(() => {
                setSubmitting(false);
              });
          }}
          className="me-3"
        >
          Yes, I want it now
        </Button>
        <Button
          btnType="tertiary"
          className="mt-2 mt-md-0"
          onClick={handleCloseAndReset}
        >
          Cancel
        </Button>
      </div>
    </Modal>
  );
};

export default GetShipmentNowModal;
